// extracted by mini-css-extract-plugin
module.exports = {"offices-list":"OfficesList_offices-list__3JvRm","offices-list__title":"OfficesList_offices-list__title__27bow"};